import { combineEpics } from 'redux-observable';
import { from, pipe, of } from 'rxjs';
import { RootEpic } from 'app/app.epics.type';
import { paymentSlice } from 'logic/store/payment/payment.slice';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { filter, ignoreElements, switchMap, tap, throttleTime } from 'rxjs/operators';
import { API_MULTIPLY_CALLS_TIMEOUT_MS } from 'logic/store/const';
import { handleCancelSubscriptionDialog } from './cancel-subscription.logic';
import { closeConfirmModal } from 'logic/modals/confirm-modal/confirm-modal';
import { logSlice } from 'logic/store/log/log.slice';

const tryCancelSubscription$: RootEpic = (action$, _, { dispatch, ofIsAuthenticated }) =>
  action$.pipe(
    filter(paymentSlice.actions.tryCancelSubscription.match),
    throttleTime(API_MULTIPLY_CALLS_TIMEOUT_MS),
    ofIsAuthenticated(),
    tap(() =>
      handleCancelSubscriptionDialog({
        onDialogResponseCancel: closeConfirmModal,
        onDialogResponseOK: () => dispatch(paymentSlice.actions.cancelSubscription()),
      })
    ),
    ignoreElements()
  );

const cancelSubscription$: RootEpic = (action$, _, { managed, paymentApi }) =>
  action$.pipe(
    filter(paymentSlice.actions.cancelSubscription.match),
    managed(
      paymentSlice.actions.cancelSubscription,
      pipe(
        switchMap(() => from(paymentApi.cancelSubscription())),
        switchMap((subscriptionsRes) =>
          of(
            paymentSlice.actions.setSubscriptions(subscriptionsRes.data?.data),
            logSlice.actions.logSuccess({
              message: translate(
                translationKeys.tutoringInstituteProfile.subscriptions.cancelSubscription
                  .notification
              ),
            })
          )
        )
      )
    )
  );

export const cancelSubscriptionEpics$ = combineEpics(tryCancelSubscription$, cancelSubscription$);
